import { ExoticActivity, ActivityId, ActivityType } from './enums/activities'
import { Expansions } from './enums/expansions'
import { BeyondLightSeasonHashes, EdgeOfFateSeasonHashes, FinalShapeEpisodeHashes,
  LightfallSeasonHashes, RenegadesSeasonHashes, ShadowkeepSeasonHashes, WitchQueenSeasonHashes } from './enums/seasons'
import { FinalShapeDungeonHashes, LightfallDungeonHashes, WitchQueenDungeonHashes } from './enums/dungeons'
import { ExoticElement, ExoticSourceExpansion, ExoticSourceType, ExoticType, ExoticWeapon, ReleaseId } from './enums/releases'

export const exoticActivities: ExoticActivity[] = [
  {
    name: 'Last Wish',
    id: ActivityId.LastWish,
    type: ActivityType.Raid,
    date: new Date('2018-09-14 17:00:00 UTC'),
    releasedWith: Expansions.Forsaken,
    ownership: [Expansions.Forsaken],
    description: `The One Thousand Voices exotic fusion rifle is a random drop from the Last Wish raid. It requires the Forsaken Pack to acquire.`,
    collectible: 199171385,
    isGuaranteed: false,
    allActivityHashes: [1661734046, 2122313384, 2214608156, 2214608157],
    element: ExoticElement.Solar,
    weaponType: ExoticType.FusionRifle,
  },
  {
    name: 'Shattered Throne',
    id: ActivityId.ShatteredThrone,
    type: ActivityType.Dungeon,
    date: new Date('2018-09-25 17:00:00 UTC'),
    releasedWith: Expansions.Forsaken,
    ownership: [Expansions.Forsaken],
    description: `The Wish-Ender exotic bow is a guaranteed reward from a quest inside the Shattered Throne dungeon. It requires the Forsaken pack to acquire.`,
    collectible: 1660030044,
    isGuaranteed: true,
    allActivityHashes: [2032534090],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Bow,
    guide: `## Guide

First, you must obtain the 'Hunter's Remembrance' quest from Petra Venj on the Dreaming City or the Quest Archive on the Tower. She will award you the Awoken Mementos, which requires an empty slot in your kinetic weapon slot to acquire.

Once you have the Awoken Mementos, you can go to the Shattered Throne dungeon and find the three bosses to kill. Once defeated, you may proceed after the second encounter and interact with the statue to acquire the Wish-Ender.`,
  },
  {
    name: 'Garden of Salvation',
    id: ActivityId.GardenOfSalvation,
    type: ActivityType.Raid,
    date: new Date('2019-10-05 17:00:00 UTC'),
    releasedWith: Expansions.Shadowkeep,
    ownership: [Expansions.Shadowkeep],
    description: `The Divinity exotic trace rifle is a guaranteed reward from a quest inside the Garden of Salvation raid. It requires the Shadowkeep pack to acquire.`,
    collectible: 1988948484,
    isGuaranteed: true,
    allActivityHashes: [
      1042180643, 2497200493, 2659723068, 3458480158, 3845997235,
    ],
    element: ExoticElement.Arc,
    weaponType: ExoticType.TraceRifle,
  },
  {
    name: 'Pit of Heresy',
    id: ActivityId.PitOfHeresy,
    type: ActivityType.Dungeon,
    date: new Date('2019-10-29 17:00:00 UTC'),
    releasedWith: Expansions.Shadowkeep,
    ownership: [Expansions.Shadowkeep],
    description: `The Xenophage exotic machine gun is a guaranteed reward from a quest inside the Pit of Heresy dungeon. It requires the Shadowkeep pack to acquire.`,
    collectible: 1258579677,
    isGuaranteed: true,
    allActivityHashes: [
      785700673, 785700678, 1375089621, 2559374368, 2559374374, 2559374375,
      2582501063,
    ],
    element: ExoticElement.Solar,
    weaponType: ExoticType.MachineGun,
  },
  {
    name: 'Deep Stone Crypt',
    id: ActivityId.DeepStoneCrypt,
    type: ActivityType.Raid,
    date: new Date('2020-11-21 17:00:00 UTC'),
    releasedWith: Expansions.BeyondLight,
    ownership: [Expansions.BeyondLight],
    description: `The Eyes of Tomorrow exotic rocket launcher is a random drop from the Deep Stone Crypt raid. It requires the Beyond Light pack to acquire.`,
    collectible: 753200559,
    isGuaranteed: false,
    allActivityHashes: [910380154, 3976949817],
    element: ExoticElement.Arc,
    weaponType: ExoticType.RocketLauncher,
  },
  {
    name: 'Presage',
    id: ActivityId.Presage,
    type: ActivityType.ExoticMission,
    date: new Date('2021-02-16 17:00:00 UTC'),
    releasedWith: BeyondLightSeasonHashes.Chosen,
    ownership: [],
    description: `The Dead Man's Tale exotic scout rifle is a guaranteed drop from the Presage exotic mission. It is available to all players.`,
    collectible: 3324472233,
    isGuaranteed: true,
    allActivityHashes: [2124066889, 3883295757, 4201846671, 4212753278],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.ScoutRifle,
  },
  {
    name: 'Vault of Glass',
    id: ActivityId.VaultOfGlass,
    type: ActivityType.Raid,
    date: new Date('2021-05-22 17:00:00 UTC'),
    releasedWith: BeyondLightSeasonHashes.Splicer,
    ownership: [],
    description: `The Vex Mythoclast exotic fusion rifle is a random drop from the Vault of Glass raid. It is available to all players.`,
    collectible: 2300465938,
    isGuaranteed: false,
    allActivityHashes: [
      1485585878, 1681562271, 3022541210, 3711931140, 3881495763,
    ],
    element: ExoticElement.Solar,
    weaponType: ExoticType.FusionRifle,
  },
  {
    name: 'Grasp of Avarice',
    id: ActivityId.GraspOfAvarice,
    type: ActivityType.Dungeon,
    date: new Date('2021-12-07 17:00:00 UTC'),
    releasedWith: Expansions.Anniversary30th,
    ownership: [Expansions.Anniversary30th],
    description: `The Gjallarhorn exotic rocket launcher is a guaranteed reward from a quest inside the Grasp of Avarice dungeon. It requires the 30th Anniversary pack to acquire.`,
    collectible: 4027219968,
    isGuaranteed: true,
    allActivityHashes: [1112917203, 3774021532, 4078656646],
    element: ExoticElement.Solar,
    weaponType: ExoticType.RocketLauncher,
    guide: `## Guide

Acquire the quest 'And Out Fly the Wolves' from either Shaw Han on the Cosmodrome, Xûr on the Treasure Hoard or the Quest Archive on the Tower. Then, complete the dungeon Grasp of Avarice and complete the quest by killing enemies and completing a Lost Sector to secure your reward.`,
  },
  {
    name: 'Vox Obscura',
    id: ActivityId.VoxObscura,
    type: ActivityType.ExoticMission,
    date: new Date('2022-02-22 17:00:00 UTC'),
    releasedWith: WitchQueenSeasonHashes.Risen,
    ownership: [],
    description: `The Dead Messenger exotic grenade launcher is a guaranteed drop from the Vox Obscura exotic mission. It is available to all players.`,
    collectible: 360554695,
    isGuaranteed: true,
    allActivityHashes: [613120446, 666172264, 901429423, 2668737148],
    element: ExoticElement.Arc,
    weaponType: ExoticType.GrenadeLauncher,
  },
  {
    name: 'Vow of the Disciple',
    id: ActivityId.VowOfTheDisciple,
    type: ActivityType.Raid,
    date: new Date('2022-03-05 17:00:00 UTC'),
    releasedWith: Expansions.TheWitchQueen,
    ownership: [Expansions.TheWitchQueen],
    description: `The Collective Obligation exotic pulse rifle is a random drop from the Vow of the Disciple raid. it requires the Witch Queen expansion to acquire.`,
    collectible: 2817568609,
    isGuaranteed: false,
    allActivityHashes: [
      1441982566, 2906950631, 3889634515, 4156879541, 4217492330,
    ],
    element: ExoticElement.Void,
    weaponType: ExoticType.PulseRifle,
  },
  {
    name: 'Duality',
    id: ActivityId.Duality,
    type: ActivityType.Dungeon,
    date: new Date('2022-05-27 17:00:00 UTC'),
    releasedWith: WitchQueenSeasonHashes.Haunted,
    ownership: [WitchQueenDungeonHashes.Duality],
    description: `The Heartshadow exotic sword is a random drop from the Duality dungeon. It requires the Witch Queen Dungeon Key to acquire.`,
    collectible: 467760883,
    isGuaranteed: false,
    allActivityHashes: [1668217731, 2823159265, 3012587626],
    element: ExoticElement.Void,
    weaponType: ExoticType.Sword,
  },
  {
    name: 'King\'s Fall',
    id: ActivityId.KingsFall,
    type: ActivityType.Raid,
    date: new Date('2022-08-26 17:00:00 UTC'),
    releasedWith: WitchQueenSeasonHashes.Plunder,
    ownership: [],
    description: `The Touch of Malice exotic scout rifle is a random drop from the King's Fall raid. It is available to all players.`,
    collectible: 192937277,
    isGuaranteed: false,
    allActivityHashes: [
      1063970578, 1374392663, 2897223272, 2964135793, 3257594522,
    ],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.ScoutRifle,
  },
  {
    name: 'Spire of the Watcher',
    id: ActivityId.SpireOfTheWatcher,
    type: ActivityType.Dungeon,
    date: new Date('2022-12-09 17:00:00 UTC'),
    releasedWith: WitchQueenSeasonHashes.Seraph,
    ownership: [WitchQueenDungeonHashes.SpireOfTheWatcher],
    description: `The Hierarchy of Needs exotic bow is a random drop from the Spire of the Watcher dungeon. It requires the Witch Queen Dungeon Key to acquire.`,
    collectible: 3558330464,
    isGuaranteed: false,
    allActivityHashes: [1262462921, 1801496203, 2296818662],
    element: ExoticElement.Solar,
    weaponType: ExoticType.Bow,
  },
  {
    name: 'Operation: Seraph\'s Shield',
    id: ActivityId.OperationSeraphShield,
    type: ActivityType.ExoticMission,
    date: new Date('2022-12-20 17:00:00 UTC'),
    releasedWith: WitchQueenSeasonHashes.Seraph,
    ownership: [],
    description: `The Revision Zero exotic pulse rifle is a guaranteed drop from the Operation: Seraph's Shield exotic mission. It is available to all players.`,
    collectible: 1161231112,
    isGuaranteed: true,
    allActivityHashes: [202306511, 995051012, 1221538367, 2919809209],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.PulseRifle,
  },
  {
    name: '//node.ovrd.AVALON//',
    id: ActivityId.NodeOvrdAvalon,
    type: ActivityType.ExoticMission,
    date: new Date('2023-03-07 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.Defiance,
    ownership: [],
    description: `The Vexcalibur exotic glaive is a guaranteed drop from the //node.ovrd.AVALON// exotic mission. It is available to all players.`,
    collectible: 2629609052,
    isGuaranteed: true,
    allActivityHashes: [3083261666, 3755529435],
    element: ExoticElement.Void,
    weaponType: ExoticType.Glaive,
  },
  {
    name: 'Root of Nightmares',
    id: ActivityId.RootOfNightmares,
    type: ActivityType.Raid,
    date: new Date('2023-03-10 17:00:00 UTC'),
    releasedWith: Expansions.Lightfall,
    ownership: [Expansions.Lightfall],
    description: `The Conditional Finality exotic shotgun is a random drop from the Root of Nightmares raid. It requires the Lightfall expansion to acquire.`,
    collectible: 2553509474,
    isGuaranteed: false,
    allActivityHashes: [2381413764, 2918919505],
    element: ExoticElement.Stasis,
    weaponType: ExoticType.Shotgun,
  },
  {
    name: 'Ghosts of the Deep',
    id: ActivityId.GhostsOfTheDeep,
    type: ActivityType.Dungeon,
    date: new Date('2023-05-26 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.Deep,
    ownership: [LightfallDungeonHashes.GhostsOfTheDeep],
    description: `The Navigator exotic trace rifle is a random drop from the Ghosts of the Deep dungeon. It requires the Lightfall Dungeon Key to acquire.`,
    collectible: 161963863,
    isGuaranteed: false,
    allActivityHashes: [313828469, 2716998124],
    element: ExoticElement.Strand,
    weaponType: ExoticType.TraceRifle,
  },
  {
    name: 'Crota\'s End',
    id: ActivityId.CrotasEnd,
    type: ActivityType.Raid,
    date: new Date('2023-09-01 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.Witch,
    ownership: [],
    description: `The Necrochasm exotic auto rifle is a random drop from the Crota's End raid. It is available to all players.`,
    collectible: 203521123,
    isGuaranteed: false,
    allActivityHashes: [156253568, 1507509200, 4179289725],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
  },
  {
    name: 'Warlord\'s Ruin',
    id: ActivityId.WarlordsRuin,
    type: ActivityType.Dungeon,
    date: new Date('2023-12-01 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.Wish,
    ownership: [LightfallDungeonHashes.WarlordsRuin],
    description: `The Buried Bloodline exotic sidearm is a random drop from the Warlord's Ruin dungeon. It requires the Lightfall Dungeon Key to acquire.`,
    collectible: 3275654322,
    isGuaranteed: false,
    allActivityHashes: [2004855007, 2534833093],
    element: ExoticElement.Void,
    weaponType: ExoticType.Sidearm,
  },
  {
    name: 'Starcrossed',
    id: ActivityId.Starcrossed,
    type: ActivityType.ExoticMission,
    date: new Date('2023-12-19 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.Wish,
    ownership: [],
    description: `The Wish-Keeper exotic bow is a guaranteed drop from the Starcrossed exotic mission. It is available to all players.`,
    collectible: 3826612761,
    isGuaranteed: true,
    allActivityHashes: [896748846, 1013336498],
    element: ExoticElement.Strand,
    weaponType: ExoticType.Bow,
  },
  {
    name: 'The Whisper',
    id: ActivityId.TheWhisper,
    type: ActivityType.ExoticMission,
    date: new Date('2024-04-09 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.IntoTheLight,
    ownership: [],
    description: `The Whisper of the Worm exotic sniper rifle is a guaranteed drop from a quest in The Whisper exotic mission. It is available to all players.`,
    collectible: 1763610692,
    isGuaranteed: true,
    allActivityHashes: [3743446313, 3871520787],
    element: ExoticElement.Solar,
    weaponType: ExoticType.SniperRifle,
    guide: `## Guide

Pick up the quest 'Whispers of the Past' from Eris Morn on the Moon, then complete the mission 'The Whisper' to acquire Whisper of the Worm.`,
  },
  {
    name: 'Zero Hour',
    id: ActivityId.ZeroHour,
    type: ActivityType.ExoticMission,
    date: new Date('2024-05-14 17:00:00 UTC'),
    releasedWith: LightfallSeasonHashes.IntoTheLight,
    ownership: [],
    description: `The Outbreak Perfected exotic pulse rifle is a guaranteed drop from a quest in the Zero Hour exotic mission. It is available to all players.`,
    collectible: 360254771,
    isGuaranteed: true,
    allActivityHashes: [3361746271, 1848771417],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.PulseRifle,
    guide: `## Guide

Pick up the quest 'Asset Protection' from Ada-1 on the Tower, then complete the mission 'Zero Hour' to acquire Outbreak Perfected.`,
  },
  {
    name: 'Salvation\'s Edge',
    id: ActivityId.SalvationsEdge,
    type: ActivityType.Raid,
    date: new Date('2024-06-07 17:00:00 UTC'),
    releasedWith: Expansions.FinalShape,
    ownership: [Expansions.FinalShape],
    description: `The Euphony exotic linear fusion rifle is a random drop from the Salvation's Edge raid. It requires The Final Shape expansion to acquire.`,
    collectible: 3411864064,
    isGuaranteed: false,
    allActivityHashes: [2192826039, 1541433876],
    element: ExoticElement.Strand,
    weaponType: ExoticType.LinearFusionRifle,
  },
  {
    name: 'Encore',
    id: ActivityId.Encore,
    type: ActivityType.ExoticMission,
    date: new Date('2024-08-27 17:00:00 UTC'),
    releasedWith: FinalShapeEpisodeHashes.Echoes,
    ownership: [],
    description: `The Choir of One exotic auto rifle is a guaranteed drop from the Encore exotic mission. It is available to all players.`,
    collectible: 2176629195,
    isGuaranteed: true,
    allActivityHashes: [
      1550266704, 3542111804, 3542111805, 3542111807, 655052177, 2741939455,
      2362862865, 2362862867, 2362862866,
    ],
    element: ExoticElement.Void,
    weaponType: ExoticType.AutoRifle,
  },
  {
    name: 'Vesper\'s Host',
    id: ActivityId.VespersHost,
    type: ActivityType.Dungeon,
    date: new Date('2024-10-11 17:00:00 UTC'),
    releasedWith: FinalShapeEpisodeHashes.Revenant,
    ownership: [FinalShapeDungeonHashes.VespersHost],
    description: `The Ice Breaker exotic sniper rifle is a random drop from the Vesper's Host dungeon. It requires the Final Shape Dungeon Key to acquire.`,
    collectible: 1643809765,
    isGuaranteed: false,
    allActivityHashes: [300092127, 4293676253],
    element: ExoticElement.Solar,
    weaponType: ExoticType.SniperRifle,
  },
  {
    name: 'Kell\'s Fall',
    id: ActivityId.KellsFall,
    type: ActivityType.ExoticMission,
    date: new Date('2025-01-07 17:00:00 UTC'),
    releasedWith: FinalShapeEpisodeHashes.Revenant,
    ownership: [],
    description: `The Slayer's Fang exotic shotgun is a guaranteed drop from the Kell's Fall exotic mission. It is available to all players.`,
    collectible: 2454134342,
    isGuaranteed: true,
    allActivityHashes: [
      3212612420, 3296787721, 715393254, 1583447699, 133833536, 264074906,
      1044034163, 3447248293,
    ],
    element: ExoticElement.Void,
    weaponType: ExoticType.Shotgun,
  },
  {
    name: 'Sundered Doctrine',
    id: ActivityId.SunderedDoctrine,
    type: ActivityType.Dungeon,
    date: new Date('2025-02-07 17:00:00 UTC'),
    releasedWith: FinalShapeEpisodeHashes.Heresy,
    ownership: [FinalShapeDungeonHashes.SunderedDoctrine],
    description: `The Finality's Auger exotic linear fusion rifle is a random drop from the Sundered Doctrine dungeon. It requires the Final Shape Dungeon Key to acquire.`,
    collectible: 1585644854,
    isGuaranteed: false,
    allActivityHashes: [247869137, 3521648250, 3834447244],
    element: ExoticElement.Solar,
    weaponType: ExoticType.LinearFusionRifle,
  },
  {
    name: 'Derealize',
    id: ActivityId.Derealize,
    type: ActivityType.ExoticMission,
    date: new Date('2025-02-11 17:00:00 UTC'),
    releasedWith: FinalShapeEpisodeHashes.Heresy,
    ownership: [],
    description: `The Barrow-Dyad exotic submachine gun is a guaranteed drop from the Derealize exotic mission. It is available to all players.`,
    collectible: 2756203682,
    isGuaranteed: true,
    allActivityHashes: [1503312592, 648675065, 1402729521, 2883193556],
    element: ExoticElement.Strand,
    weaponType: ExoticType.SubmachineGun,
  },
  {
    name: 'Desert Perpetual',
    id: ActivityId.DesertPerpetual,
    type: ActivityType.Raid,
    date: new Date('2025-07-18 17:00:00 UTC'),
    releasedWith: Expansions.EdgeOfFate,
    ownership: [Expansions.EdgeOfFate],
    description: `The Whirling Ovation exotic rocket launcher is a random drop from the Desert Perpetual raid. It requires the Edge of Fate expansion to acquire.`,
    collectible: 2519524947,
    isGuaranteed: false,
    allActivityHashes: [1044919065],
    element: ExoticElement.Strand,
    weaponType: ExoticType.RocketLauncher,
  },
  {
    name: 'Heliostat',
    id: ActivityId.Heliostat,
    type: ActivityType.ExoticMission,
    date: new Date('2025-10-07 17:00:00 UTC'),
    releasedWith: EdgeOfFateSeasonHashes.AshAndIron,
    ownership: [],
    description: `The Wolfsbane exotic sword is a guaranteed drop from the Heliostat exotic mission. It is available to all players.`,
    collectible: 1237086548,
    isGuaranteed: true,
    allActivityHashes: [1402745928, 3296536505, 4025763100, 4129522203],
    element: ExoticElement.Solar,
    weaponType: ExoticType.Sword,
  },
  {
    name: 'Fire and Ice',
    id: ActivityId.FireAndIce,
    type: ActivityType.ExoticMission,
    date: new Date('2025-12-02 17:00:00 UTC'),
    releasedWith: Expansions.Renegades,
    ownership: [Expansions.Renegades],
    description: `The Praxic Blade exotic sword is a guaranteed drop from the Fire and Ice exotic mission. It requires the Renegades expansion to acquire.`,
    collectible: 3151324440,
    isGuaranteed: true,
    allActivityHashes: [4012069357],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Sword,
  },
  {
    name: 'Equilibrium',
    id: ActivityId.Equilibrium,
    type: ActivityType.Dungeon,
    date: new Date('2025-12-13 17:00:00 UTC'),
    releasedWith: Expansions.Renegades,
    ownership: [Expansions.Renegades],
    description: `The Heirloom exotic combat bow is a random drop from the Equilibrium dungeon. It requires the Renegades expansion to acquire.`,
    collectible: 515926065,
    isGuaranteed: false,
    allActivityHashes: [2727361621, 1754635208],
    element: ExoticElement.Solar,
    weaponType: ExoticType.Bow,
  },
  {
    name: 'Oblation: Bloodline',
    id: ActivityId.OblationBloodline,
    type: ActivityType.ExoticMission,
    date: new Date('2026-06-09 17:00:00 UTC'),
    releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
    ownership: [],
    description: `The Cull's Shadow exotic fusion rifle is a guaranteed drop from the Oblation: Bloodline exotic mission. It is available to all players.`,
    collectible: 3331690812,
    isGuaranteed: true,
    allActivityHashes: [866585819],
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.FusionRifle,
    guide: `## Guide

Launch the Scarlet Keep strike with a Weapon of Sorrow in your inventory. Once you reach the tower, look for Renegades Cabal enemies; their presence confirms you are on the right track. In the final boss room, destroy the Symbols with the Weapon of Sorrow to open the back door, then proceed through the gates and enter the room on the right to interact with the Hive Object.

Travel to the Moon and locate dead Cabal bodies in each region: Archer's Line, Anchor of Light, Hellmouth and Sorrow's Harbor. The Soulfire Frequency bar on your screen will indicate when you are near one. Interacting with each body will reveal the location of another Hive Object, and a trail of dead bodies will guide you if you get lost. Interact with all of them to reveal the hidden mission. Complete the mission to acquire Cull's Shadow.`,
  },
]
export const otherExotics: ExoticWeapon[] = [
  // World
  {
    name: 'Sweet Business',
    description:
      'The Sweet Business exotic auto rifle is a random drop from any generic Exotic Engram or at the end of activities, or is obtained from a quest with Shaw Han.',
    collectible: 564802917,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'The Queen Beckons' from Shaw Han on the Cosmodrome or the Quest Archive on the Tower.

Then, defeat enemies and do public events on various destinations until you can go back to Shaw Han for your reward.`,
  },
  {
    name: 'Vigilance Wing',
    description:
      'The Vigilance Wing exotic pulse rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802919,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.PulseRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Crimson',
    description:
      'The Crimson exotic hand cannon is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802912,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [],
    releasedWith: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
  },
  {
    name: 'The Jade Rabbit',
    description:
      'The Jade Rabbit exotic scout rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802915,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.ScoutRifle,
    ownership: [],
    releasedWith: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
  },
  {
    name: 'The Huckleberry',
    description:
      'The Huckleberry exotic submachine gun is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802914,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.SubmachineGun,
    ownership: [],
    releasedWith: Expansions.Warmind,
    date: new Date('2018-04-08 17:00:00 UTC'),
  },
  {
    name: 'SUROS Regime',
    description:
      'The SUROS Regime exotic auto rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802925,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
    ownership: [],
    releasedWith: Expansions.Warmind,
    date: new Date('2018-04-08 17:00:00 UTC'),
  },
  {
    name: 'Coldheart',
    description:
      'The Coldheart exotic trace rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028070,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.TraceRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Merciless',
    description:
      'The Merciless exotic fusion rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028078,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.FusionRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Fighting Lion',
    description:
      'The Fighting Lion exotic grenade launcher is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028071,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Sunshot',
    description:
      'The Sunshot exotic hand cannon is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028068,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.HandCannon,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Graviton Lance',
    description:
      'The Graviton Lance exotic pulse rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028069,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.PulseRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Skyburner\'s Oath',
    description:
      'The Skyburner\'s Oath exotic scout rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028066,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.ScoutRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Borealis',
    description:
      'The Borealis exotic sniper rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951317,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.SniperRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Riskrunner',
    description:
      'The Riskrunner exotic submachine gun is a random drop from any generic Exotic Engram or at the end of activities, or is obtained from a quest with Zavala.',
    collectible: 1657028067,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.SubmachineGun,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'A Spark of Hope' from Zavala on the Tower. Then, progress through the steps clearing lost sectors until you get to the 'Risk/Reward' mission. At the end of the mission, you will pick up the Riskrunner.`,
  },
  {
    name: 'Hard Light',
    description:
      'The Hard Light exotic auto rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1657028064,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.AutoRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Prometheus Lens',
    description:
      'The Prometheus Lens exotic trace rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951316,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.TraceRifle,
    ownership: [],
    releasedWith: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
  },
  {
    name: 'Telesto',
    description:
      'The Telesto exotic fusion rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951319,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.FusionRifle,
    ownership: [],
    releasedWith: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
  },
  {
    name: 'The Prospector',
    description:
      'The Prospector exotic grenade launcher is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171391,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'The Wardcliff Coil',
    description:
      'The Wardcliff Coil exotic rocket launcher is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171390,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.RocketLauncher,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Tractor Cannon',
    description:
      'The Tractor Cannon exotic shotgun is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 2094776121,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.Shotgun,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'D.A.R.C.I.',
    description:
      'The D.A.R.C.I. exotic sniper rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 3695595899,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.SniperRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'The Colony',
    description:
      'The Colony exotic grenade launcher is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171388,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.RedWar_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [],
    releasedWith: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
  },
  {
    name: 'Thunderlord',
    description:
      'The Thunderlord exotic light machine gun is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 3249389111,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.MachineGun,
    ownership: [],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-11-13 17:00:00 UTC'),
  },
  {
    name: 'Cerberus+1',
    description:
      'The Cerberus+1 exotic auto rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 564802924,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Arbalest',
    description:
      'The Arbalest exotic linear fusion rifle is a random drop from any generic Exotic Engram or at the end of activities, or is obtained from a quest with Shaw Han.',
    collectible: 2036397919,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.LinearFusionRifle,
    ownership: [],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-04-16 17:00:00 UTC'),
    guide: `## Guide

Talk with Shaw Han on the Cosmodrome to pick up the quest 'The Heart's Depths', or go to the Quest Archive on the Tower and pick up the quest 'The Heart's Depths' or 'Another Last City'. Then, defeat foes with abilities and Linear Fusion Rifles, complete missions and speak with Banshee-44 on the Tower to progress. You will eventually receive the Arbalest.

If you don't have the expansion, you may still acquire the weapon randomly or buy it from Xûr.`,
  },
  {
    name: 'Trinity Ghoul',
    description:
      'The Trinity Ghoul exotic bow is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951312,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Bow,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Wavesplitter',
    description:
      'The Wavesplitter exotic trace rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951315,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.TraceRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Lord of Wolves',
    description:
      'The Lord of Wolves exotic shotgun is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1642951314,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Shotgun,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Two-Tailed Fox',
    description:
      'The Two-Tailed Fox exotic rocket launcher is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171384,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Solar,
    weaponType: ExoticType.RocketLauncher,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Black Talon',
    description:
      'The Black Talon exotic sword is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171383,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Void,
    weaponType: ExoticType.Sword,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'The Queenbreaker',
    description:
      'The Queenbreaker exotic linear fusion rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 199171382,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Forsaken_World,
    element: ExoticElement.Arc,
    weaponType: ExoticType.LinearFusionRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Monte Carlo',
    description:
      'The Monte Carlo exotic auto rifle is a random drop from any generic Exotic Engram or at the end of activities.',
    collectible: 1501322721,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.Shadowkeep_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.Shadowkeep],
    releasedWith: Expansions.Shadowkeep,
    date: new Date('2019-10-01 17:00:00 UTC'),
  },
  {
    name: 'Hawkmoon',
    description:
      'The Hawkmoon exotic hand cannon is a purchasable weapon from Xûr.',
    collectible: 653763964,
    type: ExoticSourceType.WorldDrop,
    source: ExoticSourceExpansion.BeyondLight_World,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Hunt,
    date: new Date('2020-12-08 17:00:00 UTC'),
  },
  {
    name: 'Turncoat',
    description:
      'The Turncoat exotic hand cannon is obtainable in the Rewards Pass during Season: Lawless.',
    collectible: 3776794515,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Renegades_Season,
    element: ExoticElement.Void,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Renegades],
    releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
    date: new Date('2026-06-09 17:00:00 UTC'),
  },

  // Archive
  {
    name: 'Sturm',
    description:
      'The Sturm exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 564802916,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.HandCannon,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Rat King',
    description:
      'The Rat King exotic sidearm is obtainable in the Monument to Lost Light archives.',
    collectible: 564802918,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Sidearm,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'MIDA Multi-Tool',
    description:
      'The MIDA Multi-Tool exotic scout rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 564802913,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.ScoutRifle,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-06 17:00:00 UTC'),
  },
  {
    name: 'Polaris Lance',
    description:
      'The Polaris Lance exotic scout rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1642951318,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.ScoutRifle,
    ownership: [],
    releasedWith: Expansions.Warmind,
    date: new Date('2018-05-08 17:00:00 UTC'),
  },
  {
    name: 'Legend of Acrius',
    description:
      'The Legend of Acrius exotic shotgun is obtainable in the Monument to Lost Light archives.',
    collectible: 199171389,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Shotgun,
    ownership: [],
    releasedWith: Expansions.Destiny2,
    date: new Date('2017-09-13 17:00:00 UTC'),
  },
  {
    name: 'Worldline Zero',
    description:
      'The Worldline Zero exotic sword is obtainable in the Monument to Lost Light archives.',
    collectible: 199171387,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Sword,
    ownership: [],
    releasedWith: Expansions.Warmind,
    date: new Date('2018-05-08 17:00:00 UTC'),
  },
  {
    name: 'Sleeper Simulant',
    description:
      'The Sleeper Simulant exotic linear fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 199171386,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.RedWar_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.LinearFusionRifle,
    ownership: [],
    releasedWith: Expansions.Warmind,
    date: new Date('2018-05-08 17:00:00 UTC'),
  },
  {
    name: 'Ace of Spades',
    description:
      'The Ace of Spades exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 1660030046,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
  },
  {
    name: 'Izanagi\'s Burden',
    description:
      'The Izanagi\'s Burden exotic sniper rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 24541428,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.SniperRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-01-11 17:00:00 UTC'),
  },
  {
    name: 'The Last Word',
    description:
      'The Last Word exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 3074058273,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-01-29 17:00:00 UTC'),
  },
  {
    name: 'Thorn',
    description:
      'The Thorn exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 4009683574,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-03-12 17:00:00 UTC'),
  },
  {
    name: 'Lumina',
    description:
      'The Lumina exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 2924632392,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-07-02 17:00:00 UTC'),
  },
  {
    name: 'Bad Juju',
    description:
      'The Bad Juju exotic pulse rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 4207100358,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.PulseRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-07-09 17:00:00 UTC'),
  },
  {
    name: 'Le Monarque',
    description:
      'The Le Monarque exotic bow is obtainable in the Monument to Lost Light archives.',
    collectible: 3573051804,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.Bow,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2018-12-04 17:00:00 UTC'),
  },
  {
    name: 'Jötunn',
    description:
      'The Jötunn exotic fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 3584311877,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.FusionRifle,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-01-9 17:00:00 UTC'),
  },
  {
    name: 'Tarrabah',
    description:
      'The Tarrabah exotic submachine gun is obtainable in the Monument to Lost Light archives.',
    collectible: 2329697053,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.SubmachineGun,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-06-04 17:00:00 UTC'),
  },
  {
    name: 'Anarchy',
    description:
      'The Anarchy exotic grenade launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 2220014607,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2018-12-07 17:00:00 UTC'),
  },
  {
    name: 'Truth',
    description:
      'The Truth exotic rocket launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 1763840761,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.RocketLauncher,
    ownership: [Expansions.Forsaken],
    releasedWith: Expansions.AnnualPass,
    date: new Date('2019-06-11 17:00:00 UTC'),
  },
  {
    name: 'Bastion',
    description:
      'The Bastion exotic fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 3207791447,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.FusionRifle,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Dawn,
    date: new Date('2020-01-20 17:00:00 UTC'),
  },
  {
    name: 'Witherhoard',
    description:
      'The Witherhoard exotic grenade launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 1250332035,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Arrivals,
    date: new Date('2020-06-09 17:00:00 UTC'),
  },
  {
    name: 'Traveler\'s Chosen',
    description:
      'The Traveler\'s Chosen exotic sidearm is obtainable in the Monument to Lost Light archives.',
    collectible: 1370087379,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Arrivals,
    date: new Date('2020-09-08 17:00:00 UTC'),
  },
  {
    name: 'Eriana\'s Vow',
    description:
      'The Eriana\'s Vow exotic hand cannon is obtainable in the Monument to Lost Light archives.',
    collectible: 2741465947,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Undying,
    date: new Date('2019-10-01 17:00:00 UTC'),
  },
  {
    name: 'Symmetry',
    description:
      'The Symmetry exotic scout rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 47014674,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.ScoutRifle,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Dawn,
    date: new Date('2019-12-10 17:00:00 UTC'),
  },
  {
    name: 'Devil\'s Ruin',
    description:
      'The Devil\'s Ruin exotic sidearm is obtainable in the Monument to Lost Light archives.',
    collectible: 2190071629,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Dawn,
    date: new Date('2020-01-07 17:00:00 UTC'),
  },
  {
    name: 'Tommy\'s Matchbook',
    description:
      'The Tommy\'s Matchbook exotic auto rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 778561967,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Worthy,
    date: new Date('2020-03-10 17:00:00 UTC'),
  },
  {
    name: 'The Fourth Horseman',
    description:
      'The Fourth Horseman exotic shotgun is obtainable in the Monument to Lost Light archives.',
    collectible: 2318862156,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Shotgun,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Worthy,
    date: new Date('2020-03-17 17:00:00 UTC'),
  },
  {
    name: 'Ruinous Effigy',
    description:
      'The Ruinous Effigy exotic trace rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1392294260,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.TraceRifle,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Arrivals,
    date: new Date('2020-06-09 17:00:00 UTC'),
  },
  {
    name: 'Leviathan\'s Breath',
    description:
      'The Leviathan\'s Breath exotic bow is obtainable in the Monument to Lost Light archives.',
    collectible: 3552855013,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Shadowkeep_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.Bow,
    ownership: [Expansions.Shadowkeep],
    releasedWith: ShadowkeepSeasonHashes.Undying,
    date: new Date('2019-10-22 17:00:00 UTC'),
  },
  {
    name: 'Cryosthesia 77k',
    description:
      'The Cryosthesia 77k exotic sidearm is obtainable in the Monument to Lost Light archives.',
    collectible: 2817803243,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.BeyondLight_Archive,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Splicer,
    date: new Date('2021-05-11 17:00:00 UTC'),
  },
  {
    name: 'Ager\'s Scepter',
    description:
      'The Ager\'s Scepter exotic trace rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1969234607,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.BeyondLight_Archive,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.TraceRifle,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Lost,
    date: new Date('2021-08-24 17:00:00 UTC'),
  },
  {
    name: 'Duality',
    description:
      'The Duality exotic shotgun is obtainable in the Monument to Lost Light archives.',
    collectible: 478622552,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.BeyondLight_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Shotgun,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Hunt,
    date: new Date('2020-11-10 17:00:00 UTC'),
  },
  {
    name: 'Ticuu\'s Divination',
    description:
      'The Ticuu\'s Divination exotic bow is obtainable in the Monument to Lost Light archives.',
    collectible: 882572881,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.BeyondLight_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Bow,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Chosen,
    date: new Date('2021-02-09 17:00:00 UTC'),
  },
  {
    name: 'Lorentz Driver',
    description:
      'The Lorentz Driver exotic linear fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 3602500492,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.BeyondLight_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.LinearFusionRifle,
    ownership: [Expansions.BeyondLight],
    releasedWith: BeyondLightSeasonHashes.Lost,
    date: new Date('2021-08-24 17:00:00 UTC'),
  },
  {
    name: 'Grand Overture',
    description:
      'The Grand Overture exotic light machine gun is obtainable in the Monument to Lost Light archives.',
    collectible: 1256729926,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.WitchQueen_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.MachineGun,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: WitchQueenSeasonHashes.Risen,
    date: new Date('2022-02-22 17:00:00 UTC'),
  },
  {
    name: 'Trespasser',
    description:
      'The Trespasser exotic sidearm is obtainable in the Monument to Lost Light archives.',
    collectible: 77226437,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.WitchQueen_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: WitchQueenSeasonHashes.Haunted,
    date: new Date('2022-05-24 17:00:00 UTC'),
  },
  {
    name: 'Delicate Tomb',
    description:
      'The Delicate Tomb exotic fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1977134032,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.WitchQueen_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.FusionRifle,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: WitchQueenSeasonHashes.Plunder,
    date: new Date('2022-08-23 17:00:00 UTC'),
  },
  {
    name: 'The Manticore',
    description:
      'The Manticore exotic submachine gun is obtainable in the Monument to Lost Light archives.',
    collectible: 985132347,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.WitchQueen_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.SubmachineGun,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: WitchQueenSeasonHashes.Seraph,
    date: new Date('2022-12-06 17:00:00 UTC'),
  },
  {
    name: 'Verglas Curve',
    description:
      'The Verglas Curve exotic bow is obtainable in the Monument to Lost Light archives.',
    collectible: 1184569884,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.Bow,
    ownership: [Expansions.Lightfall],
    releasedWith: LightfallSeasonHashes.Defiance,
    date: new Date('2023-02-28 17:00:00 UTC'),
  },
  {
    name: 'Wicked Implement',
    description:
      'The Wicked Implement exotic scout rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1832123372,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.ScoutRifle,
    ownership: [Expansions.Lightfall],
    releasedWith: LightfallSeasonHashes.Deep,
    date: new Date('2023-07-04 17:00:00 UTC'),
  },
  {
    name: 'Centrifuse',
    description:
      'The Centrifuse exotic auto rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 2746608191,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.Lightfall],
    releasedWith: LightfallSeasonHashes.Deep,
    date: new Date('2023-05-23 17:00:00 UTC'),
  },
  {
    name: 'Quicksilver Storm',
    description:
      'The Quicksilver Storm exotic auto rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 3709294547,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Strand,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.Lightfall],
    releasedWith: Expansions.Lightfall,
    date: new Date('2023-02-28 17:00:00 UTC'),
  },
  {
    name: 'Ex Diris',
    description:
      'The Ex Diris exotic grenade launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 2375343865,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.Lightfall],
    releasedWith: LightfallSeasonHashes.Witch,
    date: new Date('2023-08-22 17:00:00 UTC'),
  },
  {
    name: 'Dragon\'s Breath',
    description:
      'The Dragon\'s Breath exotic rocket launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 3019220289,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Lightfall_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.RocketLauncher,
    ownership: [Expansions.Lightfall],
    releasedWith: LightfallSeasonHashes.Wish,
    date: new Date('2023-11-28 17:00:00 UTC'),
  },
  {
    name: 'Tessellation',
    description:
      'The Tessellation exotic fusion rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 461401987,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.FinalShape_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.FusionRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
  },
  {
    name: 'Red Death Reformed',
    description:
      'The Red Death Reformed exotic pulse rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 173880226,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.FinalShape_Archive,
    element: ExoticElement.Solar,
    weaponType: ExoticType.PulseRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: FinalShapeEpisodeHashes.Echoes,
    date: new Date('2024-06-04 17:00:00 UTC'),
  },
  {
    name: 'Alethonym',
    description:
      'The Alethonym exotic grenade launcher is obtainable in the Monument to Lost Light archives.',
    collectible: 2081206839,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Archive,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.FinalShape],
    releasedWith: FinalShapeEpisodeHashes.Revenant,
    date: new Date('2024-10-08 17:00:00 UTC'),
  },
  {
    name: 'Lodestar',
    description:
      'The Lodestar exotic trace rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 2521113225,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Archive,
    element: ExoticElement.Arc,
    weaponType: ExoticType.TraceRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: FinalShapeEpisodeHashes.Heresy,
    date: new Date('2025-02-04 17:00:00 UTC'),
  },
  {
    name: 'New Land Beyond',
    description:
      'The New Land Beyond exotic sniper rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 614512382,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.EdgeOfFate_Archive,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.SniperRifle,
    ownership: [Expansions.EdgeOfFate],
    releasedWith: Expansions.EdgeOfFate,
    date: new Date('2025-02-04 17:00:00 UTC'),
  },
  {
    name: 'Third Iteration',
    description:
      'The Third Iteration exotic scout rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 124359113,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.EdgeOfFate_Archive,
    element: ExoticElement.Void,
    weaponType: ExoticType.ScoutRifle,
    ownership: [Expansions.EdgeOfFate],
    releasedWith: EdgeOfFateSeasonHashes.Reclamation,
    date: new Date('2025-07-15 17:00:00 UTC'),
  },
  {
    name: 'New Malpais',
    description:
      'The New Malpais exotic pulse rifle is obtainable in the Monument to Lost Light archives.',
    collectible: 1714400633,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.EdgeOfFate_Archive,
    element: ExoticElement.Strand,
    weaponType: ExoticType.PulseRifle,
    ownership: [Expansions.EdgeOfFate],
    releasedWith: EdgeOfFateSeasonHashes.AshAndIron,
    date: new Date('2025-10-07 17:00:00 UTC'),
  },
  {
    name: 'Service of Luzaku',
    description:
      'The Service of Luzaku exotic machine gun is obtainable in the Monument to Lost Light archives.',
    collectible: 994319042,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Renegades_Archive,
    element: ExoticElement.Strand,
    weaponType: ExoticType.MachineGun,
    ownership: [Expansions.Renegades],
    releasedWith: RenegadesSeasonHashes.Lawless,
    date: new Date('2025-12-02 17:00:00 UTC'),
  },

  // Quest
  {
    name: 'Malfeasance',
    description:
      'The Malfeasance exotic hand cannon is obtainable in a quest with The Drifter.',
    collectible: 1660030045,
    type: ExoticSourceType.Archive,
    source: ExoticSourceExpansion.Forsaken_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.HandCannon,
    ownership: [],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-10-08 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'Malfeasance' from the Drifter or from the Quest Archive on the Tower. Then, you need to collect a Seething Heart from an Ascendant Primeval Servitor boss in Gambit, which has a random chance to spawn.

The quest sends you to kill bosses and do missions in the Dreaming City, then takes you to Gambit again to bank motes, win games, invade and kill invaders. When you are all done with the quest steps, seek out the Drifter one last time to receive Malfeasance.`,
  },
  {
    name: 'The Chaperone',
    description:
      'The Chaperone exotic shotgun is a random drop from any generic Exotic Engram or at the end of activities, or is obtained from a quest with Shaw Han.',
    collectible: 1660030047,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Forsaken_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Shotgun,
    ownership: [],
    releasedWith: Expansions.Forsaken,
    date: new Date('2018-09-04 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'Blast From the Past' from Shaw Han on the Cosmodrome, or pick up 'Blast From the Past' or 'Tex Mechanica Tournament' from the Quest Archive on the Tower.

Then, progress through the steps making kills in the Crucible, then Gambit, and finally collect your reward from Shaw Han.`,
  },
  {
    name: 'Deathbringer',
    description:
      'The Deathbringer exotic rocket launcher is obtainable in a quest with Eris Morn.',
    collectible: 888224289,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Shadowkeep_Quest,
    element: ExoticElement.Void,
    weaponType: ExoticType.RocketLauncher,
    ownership: [Expansions.Shadowkeep],
    releasedWith: Expansions.Shadowkeep,
    date: new Date('2019-10-01 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'Symphony of Death' from Eris Morn on the Moon or the Quest Archive on the Tower.

Then, go on the Moon and progress through the steps killing bosses and completing missions. You will eventually receive the Deathbringer.`,
  },
  {
    name: 'No Time to Explain',
    description:
      'The No Time to Explain exotic pulse rifle is obtainable by completing the Beyond Light campaign.',
    collectible: 2107308931,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.BeyondLight_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.PulseRifle,
    ownership: [Expansions.BeyondLight],
    releasedWith: Expansions.BeyondLight,
    date: new Date('2020-11-10 17:00:00 UTC'),
  },
  {
    name: 'Forerunner',
    description:
      'The Forerunner exotic sidearm is obtainable in a quest with Xûr.',
    collectible: 1028725073,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Event_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.Anniversary30th],
    releasedWith: Expansions.Anniversary30th,
    date: new Date('2021-12-07 17:00:00 UTC'),
    guide: `## Guide

First, pick up the quest 'Magnum Opus' from Xûr on the Treasure Hoard or the Quest Archive on the Tower.

Complete three Starhorse bounties and buy a Strange Key from Xûr, then go in the Valley area of the Treasure Hoard to find a secret area, go to Banshee-44 and claim your Forerunner.`,
  },
  {
    name: 'Cloudstrike',
    description:
      'The Cloudstrike exotic sniper rifle is obtainable as a random drop in Empire Hunts.',
    collectible: 396432035,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.BeyondLight_Quest,
    element: ExoticElement.Arc,
    weaponType: ExoticType.SniperRifle,
    ownership: [Expansions.BeyondLight],
    releasedWith: Expansions.BeyondLight,
    date: new Date('2020-11-10 17:00:00 UTC'),
  },
  {
    name: 'Salvation\'s Grip',
    description:
      'The Salvation\'s Grip exotic grenade launcher is obtainable in a quest with the Drifter.',
    collectible: 2289501267,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.BeyondLight_Quest,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.BeyondLight],
    releasedWith: Expansions.BeyondLight,
    date: new Date('2020-11-10 17:00:00 UTC'),
    guide: `## Guide

After completing the main campaign for Beyond Light, go to the Drifter on the Tower and pick up 'The Stasis Prototype' quest.

Then, kill fallen on Europa, complete Empire Hunts, go through Lost Sectors and complete missions to unlock Salvation's Grip.`,
  },
  {
    name: 'The Lament',
    description:
      'The Lament exotic sword is obtainable in a quest with Variks.',
    collectible: 3935854305,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.BeyondLight_Quest,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Sword,
    ownership: [Expansions.BeyondLight],
    releasedWith: Expansions.BeyondLight,
    date: new Date('2020-11-10 17:00:00 UTC'),
    guide: `## Guide

After completing the main campaign for Beyond Light, go to Banshee-44 on the Tower and pick up the 'Lost Lament' quest.

Then, collect dead exos on Europa and go through Europa Lost Sectors, then do the Exo Challenge and the Glassway Strike to unlock the final mission 'Reforging the Past' and obtain The Lament.`,
  },
  {
    name: 'Osteo Striga',
    description:
      'The Osteo Striga exotic submachine gun is obtainable by completing The Witch Queen campaign.',
    collectible: 1100865290,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.WitchQueen_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.SubmachineGun,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
  },
  {
    name: 'Edge of Concurrence',
    description:
      'The Edge of Concurrence exotic glaive is obtainable in a quest with Fynch.',
    collectible: 328283190,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.WitchQueen_Quest,
    element: ExoticElement.Arc,
    weaponType: ExoticType.Glaive,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    guide: `## Guide

After completing the Witch Queen campaign, acquire the 'Report: REVERSE-LURE' quest from the Evidence Board on the Enclave.

Then, kill hive on the Throne World and find an Osmic Fragment and return it to the Evidence Board to claim your glaive.

If you have already acquired one of these three exotic glaives before, you may simple claim the other ones from the Evidence Board.`,
  },
  {
    name: 'Edge of Action',
    description:
      'The Edge of Action exotic glaive is obtainable in a quest with Fynch.',
    collectible: 3810283242,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.WitchQueen_Quest,
    element: ExoticElement.Void,
    weaponType: ExoticType.Glaive,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    guide: `## Guide

After completing the Witch Queen campaign, acquire the 'Report: REVERSE-LURE' quest from the Evidence Board on the Enclave.

Then, kill hive on the Throne World and find an Osmic Fragment and return it to the Evidence Board to claim your glaive.

If you have already acquired one of these three exotic glaives before, you may simple claim the other ones from the Evidence Board.`,
  },
  {
    name: 'Edge of Intent',
    description:
      'The Edge of Intent exotic glaive is obtainable in a quest with Fynch.',
    collectible: 1089205875,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.WitchQueen_Quest,
    element: ExoticElement.Solar,
    weaponType: ExoticType.Glaive,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    guide: `## Guide

After completing the Witch Queen campaign, acquire the 'Report: REVERSE-LURE' quest from the Evidence Board on the Enclave.

Then, kill hive on the Throne World and find an Osmic Fragment and return it to the Evidence Board to claim your glaive.

If you have already acquired one of these three exotic glaives before, you may simple claim the other ones from the Evidence Board.`,
  },
  {
    name: 'Parasite',
    description:
      'The Parasite exotic grenade launcher is obtainable in a quest with Fynch.',
    collectible: 4028619089,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.WitchQueen_Quest,
    element: ExoticElement.Solar,
    weaponType: ExoticType.GrenadeLauncher,
    ownership: [Expansions.TheWitchQueen],
    releasedWith: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    guide: `## Guide

After completing the Witch Queen campaign, acquire the quest 'Of Queens and Worms' from Ikora on the Enclave.

You will need to complete Strikes and explore Lost Sectors, then finish the Parasitic Pilgrimage mission and the Parasite will be yours.`,
  },
  {
    name: 'Final Warning',
    description:
      'The Final Warning exotic sidearm is obtainable in a quest with Nimbus.',
    collectible: 2843753795,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Lightfall_Quest,
    element: ExoticElement.Strand,
    weaponType: ExoticType.Sidearm,
    ownership: [Expansions.Lightfall],
    releasedWith: Expansions.Lightfall,
    date: new Date('2023-02-28 17:00:00 UTC'),
    guide: `## Guide

After the Lightfall campaign, unlock your Strand Subclass fully and acquire the quest 'The Final Strand' from the Pouka Pond on Neptune.

Complete the quest by doing missions and killing enemies, then return to the Pouka Pond to claim your sidearm.`,
  },
  {
    name: 'Deterministic Chaos',
    description:
      'The Deterministic Chaos exotic light machine gun is obtainable in a quest with Nimbus.',
    collectible: 4226434173,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Lightfall_Quest,
    element: ExoticElement.Void,
    weaponType: ExoticType.MachineGun,
    ownership: [Expansions.Lightfall],
    releasedWith: Expansions.Lightfall,
    date: new Date('2023-02-28 17:00:00 UTC'),
    guide: `## Guide

After the Lightfall campaign, claim the quest 'Unfinished Business' from Nimbus on Neptune.

Visit the Hall of Heroes, collect Cipher Qubits from Vex and cause chaos through Vex and Cabal, then complete the mission 'What Remains' to unlock Deterministic Chaos.`,
  },
  {
    name: 'Winterbite',
    description:
      'The Winterbite exotic glaive is obtainable in a quest with Nimbus.',
    collectible: 2629609053,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Lightfall_Quest,
    element: ExoticElement.Stasis,
    weaponType: ExoticType.Glaive,
    ownership: [Expansions.Lightfall],
    releasedWith: Expansions.Lightfall,
    date: new Date('2023-02-28 17:00:00 UTC'),
    guide: `## Guide

After the Lightfall campaign, complete all Hall of Heroes quests until you unlock the 'Strider' quest.

Visit the Archivist in the Hall of Heroes and spend keys on Terminal Overload chests in all areas, then kill enemies until you can claim your reward from the Archivist.`,
  },
  {
    name: 'Khvostov 7G-0X',
    description:
      'The Khvostov 7G-0X exotic auto rifle is obtainable in a quest with Ghost.',
    collectible: 1578345208,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.AutoRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
    guide: `## Guide

After the Final Shape campaign, obtain all 9 region chests in the Pale Heart, then acquire the Lost Encryption Bits from the Cyst missions.

Collect the Legendary Khvostov from a chest in the area between The Divide and The Impasse that looks like the place you got your first common Khvostov.

Then, collect all 8 Visions of the Traveler and kill 9 unique final bosses in Overthrow to convert your 17 Motes of Light into a Mote of Primordial Light.

Finally, you can claim your Khvostov 7G-0X in a chest in the Lost City.`,
  },
  {
    name: 'Still Hunt',
    description:
      'The Still Hunt exotic sniper rifle is obtainable in a quest with Ghost.',
    collectible: 2289185883,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Quest,
    element: ExoticElement.Solar,
    weaponType: ExoticType.SniperRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
    guide: `## Guide

After the Final Shape campaign, complete the 'Destined Heroes' quest then acquire the 'Wild Card' quest from Cayde-6 at the Lost City.

Follow the missions, then come back to Cayde-6 to claim your Still Hunt.`,
  },
  {
    name: 'Ergo Sum',
    description:
      'The Ergo Sum exotic sword is obtainable in a quest with Ghost.',
    collectible: 740275358,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.Sword,
    ownership: [Expansions.FinalShape],
    releasedWith: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
    guide: `## Guide

After the Final Shape campaign, you will have obtained the 'Destined Heroes' quest.

Follow the missions, then claim rewards from Micah-10 and continue on more missions until you go back to your Ghost and return to The Sacrarium at the edge of the Pale Heart. You will then be rewarded with the Ergo Sum.`,
  },
  {
    name: 'Microcosm',
    description:
      'The Microcosm exotic trace rifle is obtainable in a quest with Ghost.',
    collectible: 3613141427,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.FinalShape_Quest,
    element: ExoticElement.Kinetic,
    weaponType: ExoticType.TraceRifle,
    ownership: [Expansions.FinalShape],
    releasedWith: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
    guide: `## Guide

After the Final Shape campaign, complete the 'Destined Heroes' quest then complete three 'Convalescence' quests from Micah-10.

The fourth quest will be 'Convalescence: Budding', which requires you to complete three story missions on Cooperative Focus difficulty. After those, you can return to Micah-10 to acquire Microcosm.`,
  },
  {
    name: 'Graviton Spike',
    description:
      'The Graviton Spike exotic hand cannon is obtainable in a quest with Lodi.',
    collectible: 46560497,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.EdgeOfFate_Quest,
    element: ExoticElement.Arc,
    weaponType: ExoticType.HandCannon,
    ownership: [Expansions.EdgeOfFate],
    releasedWith: Expansions.EdgeOfFate,
    date: new Date('2025-07-15 17:00:00 UTC'),
    guide: `## Guide

After the Edge of Fate campaign, complete the 'Graviton Through the Ages' quest with Lodi.

You will then be rewarded with the Graviton Spike.`,
  },
  {
    name: 'Heir Apparent',
    description:
      'The Heir Apparent exotic light machine gun is obtainable in a quest during Guardian Games.',
    collectible: 2842076592,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Event_Quest,
    element: ExoticElement.Solar,
    weaponType: ExoticType.MachineGun,
    ownership: [Expansions.Shadowkeep],
    releasedWith: Expansions.Shadowkeep,
    date: new Date('2020-04-22 17:00:00 UTC'),
    guide: `## Guide

Visit Eva Levante on the Tower during the Guardian Games to start the 'Top of Class' quest.

Then, earn medallions and defeat targets with machine guns until you can go back to Eva Levante for your reward.`,
  },
  {
    name: 'Fafnir',
    description:
      'The Fafnir exotic linear fusion rifle is obtainable in the Tenet of Bravery monument in the Tower.',
    collectible: 2110601068,
    type: ExoticSourceType.Quest,
    source: ExoticSourceExpansion.Event_Quest,
    element: ExoticElement.Void,
    weaponType: ExoticType.LinearFusionRifle,
    ownership: [],
    releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
    date: new Date('2026-06-09 17:00:00 UTC'),
  },
]

function activityTypeToExoticType(type: ActivityType): ExoticSourceType {
  switch (type) {
    case ActivityType.Raid:
      return ExoticSourceType.Raid
    case ActivityType.Dungeon:
      return ExoticSourceType.Dungeon
    case ActivityType.ExoticMission:
      return ExoticSourceType.ExoticMission
  }
}

function activityExpansionToExoticSource(
  type: ActivityType,
  expansion: ReleaseId,
): ExoticSourceExpansion {
  switch (expansion) {
    case Expansions.Forsaken:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.Forsaken_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.Forsaken_Dungeon
      break
    case ShadowkeepSeasonHashes.Undying:
    case ShadowkeepSeasonHashes.Dawn:
    case ShadowkeepSeasonHashes.Worthy:
    case ShadowkeepSeasonHashes.Arrivals:
    case Expansions.Shadowkeep:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.Shadowkeep_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.Shadowkeep_Dungeon
      break
    case BeyondLightSeasonHashes.Hunt:
    case BeyondLightSeasonHashes.Chosen:
    case BeyondLightSeasonHashes.Splicer:
    case BeyondLightSeasonHashes.Lost:
    case Expansions.BeyondLight:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.BeyondLight_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.BeyondLight_Dungeon
      else if (type === ActivityType.ExoticMission)
        return ExoticSourceExpansion.BeyondLight_ExoticMission
      break
    case WitchQueenSeasonHashes.Risen:
    case WitchQueenSeasonHashes.Haunted:
    case WitchQueenSeasonHashes.Plunder:
    case WitchQueenSeasonHashes.Seraph:
    case WitchQueenDungeonHashes.Duality:
    case WitchQueenDungeonHashes.SpireOfTheWatcher:
    case Expansions.TheWitchQueen:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.WitchQueen_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.WitchQueen_Dungeon
      else if (type === ActivityType.ExoticMission)
        return ExoticSourceExpansion.WitchQueen_ExoticMission
      break
    case LightfallSeasonHashes.Defiance:
    case LightfallSeasonHashes.Deep:
    case LightfallSeasonHashes.Witch:
    case LightfallSeasonHashes.Wish:
    case LightfallDungeonHashes.GhostsOfTheDeep:
    case LightfallDungeonHashes.WarlordsRuin:
    case Expansions.Lightfall:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.Lightfall_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.Lightfall_Dungeon
      else if (type === ActivityType.ExoticMission)
        return ExoticSourceExpansion.Lightfall_ExoticMission
      break
    case FinalShapeEpisodeHashes.Echoes:
    case FinalShapeEpisodeHashes.Revenant:
    case FinalShapeEpisodeHashes.Heresy:
    case FinalShapeDungeonHashes.VespersHost:
    case FinalShapeDungeonHashes.SunderedDoctrine:
    case Expansions.FinalShape:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.FinalShape_Raid
      else if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.FinalShape_Dungeon
      else if (type === ActivityType.ExoticMission)
        return ExoticSourceExpansion.FinalShape_ExoticMission
      break
    case EdgeOfFateSeasonHashes.Reclamation:
    case Expansions.EdgeOfFate:
      if (type === ActivityType.Raid)
        return ExoticSourceExpansion.EdgeOfFate_Raid
      break
    case RenegadesSeasonHashes.Lawless:
    case Expansions.Renegades:
      if (type === ActivityType.Dungeon)
        return ExoticSourceExpansion.Renegades_Dungeon
      break
  }

  return ExoticSourceExpansion.Unknown
}

function exoticActivityToWeapon(exoticActivity: ExoticActivity): ExoticWeapon {
  return {
    name: exoticActivity.name,
    description: exoticActivity.description,
    collectible: exoticActivity.collectible,
    type: activityTypeToExoticType(exoticActivity.type),
    source: activityExpansionToExoticSource(
      exoticActivity.type,
      exoticActivity.releasedWith,
    ),
    element: exoticActivity.element,
    weaponType: exoticActivity.weaponType,
    ownership: exoticActivity.ownership,
    releasedWith: exoticActivity.releasedWith,
    date: exoticActivity.date,
    guide: exoticActivity.guide,
  }
}

export function exoticActivitiesToWeapons(
  exoticActivities: ExoticActivity[],
): ExoticWeapon[] {
  return exoticActivities.map(exoticActivityToWeapon)
}
